<mat-card-header class="flex align-items-center">
  <shared-title>Actualizar licencias</shared-title>
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>

<form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Cantidad de licencias'"
        [type]="'number'"
        pattern="[0-9]*"
        (keydown)="preventDecimal($event)"
        [control]="$any(companyForm.get('usersCount'))" />
    </div>
    <mat-selection-list>
      <div class="checkbox-item text-center">
        <mat-checkbox formControlName="sendMail"></mat-checkbox>
        <span>Notificar al contacto de la empresa de la actualización</span>
      </div>
    </mat-selection-list>
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'">
      Cancelar
    </shared-button>

    <shared-button
      [disabled]="!companyForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'">
      Guardar
    </shared-button>
  </mat-dialog-actions>
</form>
